<template>
  <div
    class="flex min-h-screen w-full grow items-center justify-center bg-gray-50"
  >
    <div class="flex max-w-md flex-col items-center justify-center space-y-8">
      <ZenniIconsIcon404 size="xl" />
      <div class="text-center">
        <h2 class="text-3xl font-semibold text-gray-900">
          Sorry, page not found
        </h2>
        <p class="text-grays-dark mt-3 text-lg">
          The page you are looking for might have been removed or is temporarily
          unavailable.
        </p>
      </div>
      <ZnButton
        type="secondary"
        class="mx-auto text-center"
        @click="handleGoHome()"
        >Go to home</ZnButton
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { useClientStoreRepository } from '@/composables/api/repositories/client-store'
import { navigateTo, useRoute, definePageMeta } from '#imports'
import { useGuestStore } from '~/store/guest'

definePageMeta({
  skipMiddleware: true,
  layout: false,
})

const route = useRoute()
const { slug } = route.params

if (slug && slug.length) {
  const slugArray = Array.isArray(slug) ? slug : [slug]
  const [partnerName, partnerBrand, partnerRegion] = slugArray

  try {
    const clientStoreApi = useClientStoreRepository()
    const res = await clientStoreApi.execute<'search'>(
      clientStoreApi.search({
        partnerName,
        partnerBrand,
        partnerRegion,
      }),
    )

    if (res) {
      const partnerId = slugArray.filter(Boolean).join('.')
      await navigateTo(`/?partner=${partnerId}`)
    }
  } catch (error) {
    console.log('Not a valid partner, showing 404')
  }
}

const guestStore = useGuestStore()
const handleGoHome = () => {
  const targetPath = guestStore.gift?.id || guestStore.guest.store?.partnerName
    ? '/'
    : '/welcome'
  
  navigateTo({
    path: targetPath,
    query: route.query
  }, { external: true })
}
</script>
